// src/lib/facturation-source.js — WAGON M (Lot M3.1)
//
// SEUL point de vérité de la « source de facturation » d'un logement.
//
// Un logement peut être facturé à partir de deux sources de réservations :
//   - 'kv'  : imports CSV V1 (table KV `fbz8-*`) — comportement historique.
//   - 'v2'  : sync Beds24 V2 (table relationnelle `reservations`).
//
// ⚠️ INERTE en M3.1 : ce helper EXISTE mais AUCUN calcul ne le lit encore.
// Le câblage côté calcul de facturation viendra en M3.2 (gaté). Tant que
// M3.2 n'est pas livré, basculer le champ dans l'UI n'a AUCUN effet sur les
// montants — c'est voulu (livraison incrémentale sûre).
//
// Défaut 'kv' = ZÉRO régression : tout logement dont le champ est absent,
// null, undefined, ou porte une valeur inconnue retombe sur le comportement
// historique (imports CSV V1). M3.2 devra OBLIGATOIREMENT passer par ce
// helper plutôt que de lire `log.facturationSource` en direct.

/**
 * Résout la source de facturation d'un logement.
 *
 * Retourne 'v2' UNIQUEMENT si `log.facturationSource === 'v2'` (égalité
 * stricte). Dans TOUS les autres cas (champ absent, null, undefined, valeur
 * inconnue, ou `log` lui-même null/undefined) → 'kv' (défaut sûr,
 * zéro régression). Ce helper est le SEUL point de vérité de la source ;
 * le câblage M3.2 l'utilisera.
 *
 * @param {{ facturationSource?: string } | null | undefined} log - Le logement (cfg.props[].logs[]).
 * @returns {'kv' | 'v2'} La source de facturation résolue.
 */
export function getFacturationSource(log) {
  return log?.facturationSource === "v2" ? "v2" : "kv";
}
